var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16/percent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4685 2.41435C12.1451 2.15559 11.6731 2.20803 11.4143 2.53148L3.41435 12.5315C3.15559 12.8549 3.20803 13.3269 3.53148 13.5856C3.85493 13.8444 4.32689 13.792 4.58565 13.4685L12.5857 3.46852C12.8444 3.14507 12.792 2.6731 12.4685 2.41435Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.625 3.75C4.27982 3.75 4 4.02982 4 4.375C4 4.72018 4.27982 5 4.625 5C4.97018 5 5.25 4.72018 5.25 4.375C5.25 4.02982 4.97018 3.75 4.625 3.75ZM2.5 4.375C2.5 3.20139 3.45139 2.25 4.625 2.25C5.79861 2.25 6.75 3.20139 6.75 4.375C6.75 5.5486 5.79861 6.5 4.625 6.5C3.45139 6.5 2.5 5.5486 2.5 4.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 11C11.0298 11 10.75 11.2798 10.75 11.625C10.75 11.9702 11.0298 12.25 11.375 12.25C11.7202 12.25 12 11.9702 12 11.625C12 11.2798 11.7202 11 11.375 11ZM9.25 11.625C9.25 10.4514 10.2014 9.5 11.375 9.5C12.5486 9.5 13.5 10.4514 13.5 11.625C13.5 12.7986 12.5486 13.75 11.375 13.75C10.2014 13.75 9.25 12.7986 9.25 11.625Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.c8f45d0d.svg";
export { ForwardRef as ReactComponent };